import { Box, Grid, Stack, SvgIcon, Typography } from '@mui/material'
import ClickableCard from '../../common/clickableCard';
import SkeletonCard from '../../common/skeletonCard';
import custom from '../../../styles/mui/szVariables.json'

export default function ReferralCard({ 
        id, color, content, handleCardClick }: any) {
    if(!content) return (
        <SkeletonCard height='144px' />
    )
    return (
        <ClickableCard
                id={id}
                height="auto"
                px={custom.spacing.md}
                py={custom.spacing.md}
                handleCardClick={ ()=>handleCardClick(true)}
            >
             <Grid container direction="column" 
                    justifyContent="start" 
                    alignItems="flex-left">
                <Grid item xs width="100%">
                    <Stack alignItems="start" 
                        direction="row" 
                        width="100%"
                        justifyContent={"center"} >
                        <Box maxWidth="100%">
                            <Typography 
                                variant='szHeading.Bold.Small' 
                                id='referralTitle' >
                                {content.title}
                            </Typography>
                            <Box minWidth="150px" 
                                pt={custom.spacing.xxs}>
                                <Typography component="p" 
                                    id="referText"
                                    sx={{ color: 'text.primary' }}
                                    variant="szBody.Regular.Medium" >
                                    {content.desc}
                                </Typography>
                            </Box>
                            <Box id="referButton" width="65px"
                                sx={{ 
                                    py: custom.spacing.xxs,
                                    px: custom.spacing.xs,
                                    mt: custom.spacing.xs,
                                    backgroundColor: 'primary.main',
                                    borderRadius: custom.corners12px,
                                }}
                                onClick={ ()=>handleCardClick(true)} >
                                <Typography color="#FFF" noWrap
                                    variant='szBody.Medium.Small'>
                                 {content.buttonText}
                                </Typography>    
                            </Box>
                        </Box>
                        <Box width="152px" height="114px" ml='auto'>
                            <SvgIcon id={id+"hoverIcon"}
                                visibility="hidden"
                                viewBox='0 0 20 20'
                                sx={{ ml: 'auto', float: 'right'}} 
                                > 
                                {content.hoverIcon} 
                            </SvgIcon>
                            <Box component={"img"} 
                                    pt="20px"
                                    pl="36px"
                                    alt="icon"
                                    height="80px"
                                    width="80px"
                                    src= {content.icon}
                                    sx={{ color: 'primary.main'}}
                                /> 
                        </Box>
                    </Stack>
                </Grid>
            </Grid>  
        </ClickableCard>
    )
}